import { makeAutoObservable, observable  } from "mobx";
import { WellPerformanceService } from "../services/WellPerformanceService";
const _ = require("underscore");
class WellPerformanceStore {
  constructor() {
    makeAutoObservable(this);
  }

  selectedWell = "AKRI_03T_N/O";
  isIniatilizing = false;
  isLoadingWells = false;
  isLoading = false;
  uniqueWells = [];
  plotData = [];
  isproducing = true;
  async getuniqueWellsData() {
    try {
      this.isLoadingWells = true;

      const res = await WellPerformanceService.getuniqueWellsData(
        this.isproducing
      );
      this.uniqueWells = [...res];
      this.selectedWell = res[0];
    } catch (error) {
      throw error;
    } finally {
      this.isLoadingWells = false;
    }
  }
  async getWellPlotData(uniqueId = this.selectedWell) {
    try {
      this.isIniatilizing = true;

      const res = await WellPerformanceService.getPlotData(uniqueId);
      this.plotData = [...res];
    } catch (error) {
      throw error;
    } finally {
      this.isIniatilizing = false;
    }
  }
}



const wellPerformance = new WellPerformanceStore();
export default wellPerformance;

